module.exports = __webpack_public_path__ + "static/img/clinic-bg.efdd259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shapes/clinic-bg.png
// module id = lBC1
// module chunks = 7